import { render } from "./OboxImage.vue?vue&type=template&id=00b992d2"
const script = {}
script.render = render

export default script